import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../utils/config";
import { onErrorHandler } from "./handlers";
import { PriceOperations } from "../enums/prices";

declare const window: any;

export const pricingApi = createApi({
    reducerPath: "pricingApi",
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.LAMBDA_PRICING_CDN ?? "https://cdn-npr-pricing.api.pens.com/",
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8")
            return headers
        },
    }),
    tagTypes: ["Pricing"],
    endpoints: (builder) => ({
        getPricing: builder.mutation({
            query: ({ productKey, qty }) => ({
                url: `v1/quantity/${productKey}/${config('locale')}`,
                method: "GET",
                params: {
                    regionCode: config('regionCode'),
                    lang: config('language'),
                    qty: qty
                },
            })
        }),
        getPricesDetails: builder.mutation({
            query: (productKey) => ({
                url : `v1/prices/${productKey}/${config('locale')}`,
                method: 'GET'
            }),
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data;
                }
                catch (error) {
                    dispatch(onErrorHandler({operation: PriceOperations.GET_PRICE_DETAILS, err: JSON.stringify(error), errMsg: 'Error: while getting price details with product key', api: `${window.Config?.LAMBDA_PRICING}/v1/prices/productKey/${config('locale')}`}));     
                }
            }
        }),
    }),
});

export const { useGetPricingMutation, useGetPricesDetailsMutation } = pricingApi;
